export const getFromStorage = async (key) => {
  try {
    const data = await localStorage.getItem(key);
    if (!data) {
      throw new Error("Empty token");
    }
    return JSON.parse(data);
  } catch (err) {
    throw Error("Token Error", err);
  }
};



export const setToStorage = async (key, data) => {
  const payload = await JSON.stringify(data); //Token itself
  localStorage.setItem(key, payload);
};
